import {SystemAlertListResponse } from '../dto/ResDtoRepository';
import { sendGetApiRequest } from './apiConfig';

// ----- System Alert -----
export const getSystemAlertList = async (): Promise<SystemAlertListResponse> => {
  return sendGetApiRequest<SystemAlertListResponse>(`/api/v1/system`);
};